import { BannerImg, BannerWrapper, Content, ContentWrapper, Heading } from "./styles"

export const Banner = (props) => {
    const { img, isHome } = props

    return (
        <BannerWrapper>
            <BannerImg id='banner-img' src={img} alt='' />
            {isHome && <ContentWrapper>
                <Heading>Discover Your Dream Shop with CELESTE Mall and Multiplex</Heading>
                <Content>High-street retail establishments are the new royals of the town. With Consumer pereferences shifting toward high-street retail stores, it's high time to upgrade from traditional malls to a high street retail mall.</Content>
            </ContentWrapper>}
        </BannerWrapper>
    )
}